module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/additional-briefing-50.75413c26.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/additional-briefing-50.png
// module id = 3685
// module chunks = 11